import React from "react";
import styled from "@emotion/styled";
import SeminarCarousel from "components/SeminarCarousel";

const SeminarCarouselSectionLayout = styled.div`
  margin-top: 75px;
  text-align: center;
  max-width: 1440px;
  margin: 0 auto;

  @media screen and (max-width: 640px) {
    text-align: left;
  }

  h2 {
    font-family: ${props => props.theme.fonts.subheading};

    @media screen and (max-width: 640px) {
      font-size: 32px;
    }
  }

  p {
    font-size: 20px;

    @media screen and (max-width: 640px) {
      font-size: 16px;
    }
  }
`;

export default function SeminarCarouselSection({ data }) {
  return (
    <SeminarCarouselSectionLayout>
      <h2>{data.mainTitle}</h2>
      <p dangerouslySetInnerHTML={{ __html: data.mainDesc }} />
      {data.seminarData.map(seminar => (
        <SeminarCarousel data={seminar} key={seminar.title} />
      ))}
    </SeminarCarouselSectionLayout>
  );
}
